// COMPONENTS
import DropdownButton from "../../../../buttons/dropdown.button";

const DEFAULT_CLASSNAMES = {
  container: "flex flex-col  gap-1",
  checkbox: "hover:cursor-pointer dark:accent-darkPrimary accent-lightPrimary",
  checkboxContainer:
    "shadow shadow-secondary text-secondary bg-slate-50 flex flow-row rounded px-2",
  dropDownLabel:
    "hover:cursor-pointer w-full flex self-start p-2 text-sm font-ubuntuRegular",
};

const MultiOptionFilter = ({
  classNames = DEFAULT_CLASSNAMES,
  dropdownButtonProps = {},
  options = [],
  handleChange = () => {},
}) => {
  return (
    <DropdownButton {...dropdownButtonProps}>
      {options.length > 0 &&
        options.map((option, index) => (
          <div
            key={option?.id || index}
            className={
              classNames?.checkboxContainer ||
              DEFAULT_CLASSNAMES.checkboxContainer
            }
          >
            <input
              type="checkbox"
              id={option?.id}
              name={option?.name}
              checked={option?.checked}
              onChange={handleChange}
              data-value={option?.value}
              className={classNames?.checkbox || DEFAULT_CLASSNAMES.checkbox}
            />
            <label
              className={
                classNames?.dropDownLabel || DEFAULT_CLASSNAMES.dropDownLabel
              }
              htmlFor={option?.id}
            >
              {option?.label || ""}
            </label>
          </div>
        ))}
    </DropdownButton>
  );
};

export default MultiOptionFilter;
